export const COLORS = {
    vertClaire: "#5BFF8796",
    texteVertClaire: "#B6FFCB",
    vertFonce: "#0E2627",
    vertFonceTransp: "#367B4763",
    vertUtilisateur: "#367B47CC",
    vertFonceAssistant: "#104239EB",
    bleuClaireVerdatre: "#C2FFC4",
    bleuVertClaire: "rgb(126, 200, 169)",
    bleuClaireMoinsVert: "#a1c4c49c",
    gris: "#d0d0d05e",
    rouge: "#d01212",
    colorBlue: "#00aeef",
    colorBlueDark: "#0d2035",
    submenuWidth: "180px",
    jauneClaire: "#F4D222",
    jauneSombre: "#B9A645",
    grisClaire: "#E6E6E640",
    grisSombre: "#2D2914E5",
    grisTresSombre: "#808080f7",
    violet: "#817CFC",
    noireMoinsSombre: "#363552",
    aureliaColorBG: "#e8f5e9",
    aureliaColorTheme: "#66bb6a",
    elektraColorBG: "#3a9fd04f",
    elektraColorTheme: "#32a8f7",
    turingColorBG: "#ede7f6",
    turingColorTheme: "#7e57c2",
    blackColorDisable : "rgb(26, 20, 18)",
    blackColor: "black",
    whiteColor : "white"
}

export const CAMEMBER_COLORS = {
  green_light_blue: "rgba(75, 192, 192, 0.6)",
  red_light_white: "rgba(255, 99, 132, 1)",
  default_color: COLORS.jauneClaire,
  transparent: "rgba(255, 255, 255, 0)",
  black: "rgb(20, 20, 20)"
}

export const setThemeColorByModelName = (modelNameSelected: string) => {
    switch (modelNameSelected) {
        case "Aurelia":
          return {
            color: COLORS.aureliaColorTheme,
            backgroundColor: COLORS.aureliaColorBG,
            border: `2px solid ${COLORS.aureliaColorTheme}`
          };
        case "Turing":
          return {
            color: COLORS.turingColorTheme,
            backgroundColor: COLORS.turingColorBG,
            border: `2px solid ${COLORS.turingColorTheme}`
          };
        case "Elektra":
          return {
            color: COLORS.elektraColorTheme,
            backgroundColor: COLORS.elektraColorBG,
            border: `2px solid ${COLORS.elektraColorTheme}`
          };
        default:
            return {
                color: COLORS.jauneClaire,
                backgroundColor: COLORS.jauneSombre,
                border: `2px solid ${COLORS.grisSombre}`
              }
      }
}